export const iconFontAwesomeDesignFill = (
	<i className="fa-solid fa-fill"></i>
);
